import React from "react";
import OrganizationInlineEditInput from "./OrganizationInlineEditInput";
import InlineEditValidatedInputText from "../../common/widgets/InlineEditValidatedInputText";

/**
 * Generic component for all organization editable text fields
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function OrganizationInlineEditInputText(props) {

  return <OrganizationInlineEditInput InlineEditInputComponent={InlineEditValidatedInputText} {...props}/>
};
